/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Cta_Register_SkipperInputs */

const es_nav_cta_register_skipper = /** @type {(inputs: Nav_Cta_Register_SkipperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regístrate como patrón`)
};

const gl_nav_cta_register_skipper = /** @type {(inputs: Nav_Cta_Register_SkipperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rexístrate como patrón`)
};

const en_nav_cta_register_skipper = /** @type {(inputs: Nav_Cta_Register_SkipperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register as a skipper`)
};

/**
* | output |
* | --- |
* | "Register as a skipper" |
*
* @param {Nav_Cta_Register_SkipperInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_cta_register_skipper = /** @type {((inputs?: Nav_Cta_Register_SkipperInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Cta_Register_SkipperInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_nav_cta_register_skipper(inputs)
	if (locale === "en") return en_nav_cta_register_skipper(inputs)
	return es_nav_cta_register_skipper(inputs)
});